import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=11a7927c&"
import script from "./EditUserForm.vue?vue&type=script&lang=ts&"
export * from "./EditUserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QBtn,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QBtn,QInput})
